/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Drop_FrameInputs */



/**
* | output |
* | --- |
* | "Project Drop Frame" |
*
* @param {Project_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_drop_frame = /** @type {((inputs?: Project_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Drop frame du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt Drop Frame")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetto Drop Frame")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проектная рама")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto Drop Frame")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目落帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトドロップフレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट ड्रॉप फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto Drop Frame")
	return /** @type {LocalizedString} */ ("Project Drop Frame")
});